import {Component, OnDestroy, OnInit} from '@angular/core';
import {FlashMessage} from '../model/flashMessage';
import {Subscription} from 'rxjs';
import {AppService} from '../app.service';

@Component({
  selector: 'app-flash-message-list',
  templateUrl: './flash-message-list.component.html',
  styleUrls: ['./flash-message-list.component.css']
})
export class FlashMessageListComponent implements OnInit, OnDestroy {

  loading = true;
  show = true;
  flashMessages: FlashMessage[];
  flashMessagesSubscription = new Subscription();

  constructor(private appService: AppService) { }

  ngOnInit() {
    this.flashMessagesSubscription =
      this.appService.flashMessagesSubject
        .subscribe(data => {
          this.flashMessages = data.sort((a, b
          ) => {
            return a.datumPridania < b.datumPridania ? 1 : -1;
          });
          this.loading = false;
        });

    this.appService.fetchFlashMessages();
  }

  ngOnDestroy(): void {
    this.flashMessagesSubscription.unsubscribe();
  }
}
